<template>
  <div class="monthSelect">
    <form>
      <label for="monthSelector">Viewing </label>
      <select ref="monthSelector" name="monthSelector" id="monthSelector" v-model="monthSelector" @change="updateMonth()">
        <option v-for="month in activeMonths"
          :value="month" :key="month" v-html="formatMonth(month)"
        ></option>
      </select>
      <input type="submit" value="go" name="submit" id="monthSelectSubmit" style="display: none" />
    </form>
  </div>

</template>

<script>
// import axios from 'axios'
import {format as datefnsFormat} from 'date-fns'
import store from '@/store.js';
import API from '@/js/data/API.js'

export default {
  name: 'component-month-select',
  data () {
    return {
      activeMonths: false,
      monthSelector: false
    }
  },
  async created () {
    let params = {slug: '/api/activeMonths'}
    let data = await API.getData(params)
    this.activeMonths = data
    this.monthSelector = data[0]
    this.updateMonth()
  },
  methods: {
    updateMonth () {
      let payload = {month: this.monthSelector}
      store.dispatch('setActiveMonth', payload)
    },
    formatMonth (month) {
      month = month + '-02'
      return datefnsFormat(new Date(month), 'MMM yyyy')
    }
  }
}
</script>

<style lang="scss">
  .monthSelect {
    display: inline-flex;
    label {
      color: $brandLightGreen;
    }
    select {
        -moz-appearance: none;
        -webkit-appearance: none;
        border: medium none;
        outline: medium none;
        background-color: $brandBlack;
        color: $brandLightGreen;
    }
  }

</style>
